/* eslint-disable quotes */
import axios from 'axios'
import store from '@/store/store'
import { loading } from '@/prototypes/u/loading'

const protocol = window.location.protocol
let domain = window.location.hostname
domain = window.location.hostname.split('.').reverse()
if (domain.length > 3) {
  domain = domain.splice(0, 3)
}
domain[domain.length - 1] = `${domain[domain.length - 1]}api`
domain = domain.reverse().join('.')
domain = `${protocol}//${domain}/api`

const baseURL = process.env.VUE_APP_BASE_URL || domain
// const baseURL = 'http://127.0.0.1:8000/api/'
const API = axios.create({
  baseURL
  // You can add your headers here
})

API.interceptors.request.use(function (config) {
  // Do something before request is sent

  // throw new API.Cancel('you send sevaral request')
  // console.log(new cancelToken((cancel) => cancel('cancel repeat')).reason.message)

  config.headers['Cache-Control'] = 'no-store'
  config.headers['Content-Security-Policy'] = "default-src 'self'; script-src 'self'; style-src 'self'; font-src 'self'; img-src 'self'; frame-src 'self'"

  const exceptUrls = ['v1/profile/browser-settings']

  if (config.method !== 'get' && exceptUrls.indexOf(config.url.split('?')[0]) === -1 && config.url.indexOf('loading=false') === -1) {
    loading.show()
  }

  if (config.loading) {
    loading.show()
  }

  return config

}, function (error) {
  // Do something with request error
  // console.log('rejected')
  return Promise.reject(error)
})

API.interceptors.response.use(function (response) {
  // Do something before request is sent

  // throw new API.Cancel('you send sevaral request')
  // console.log(new cancelToken((cancel) => cancel('cancel repeat')).reason.message)

  if ((response.config.method !== 'get' && response.config.url.indexOf('loading=false') === -1) || response.config.loading) {
    loading.hide()
  }

  if (response.headers.date) {
    store.dispatch('helper/changeCurrentTime', response.headers.date)
  }

  return response
}, function (error) {
  const loggedIn = localStorage.getItem('accessToken')

  if (error.config.url.indexOf('loading=false') === -1) {
    loading.hide(true)
  }

  if (loggedIn && error.response && (error.response.status === 401 || error.response.status === 403)) {
    store.dispatch('auth/logout')
  }

  return Promise.reject(error)
})


export default API
